export default "__VITE_ASSET__Wn9GEROZ__"